// Shared order-status badge styling — aligned with backend ORDER_STATUSES
// (server.py line 138). Single source of truth used by:
//   - pages/app/OrdersListPage.jsx        (client portal — list)
//   - pages/app/OrderDetailPage.jsx       (client portal — detail)
//   - pages/superadmin/SuperAdminOrders.jsx        (admin — list)
//   - pages/superadmin/SuperAdminOrderDetail.jsx   (admin — detail)
//   - pages/superadmin/SuperAdminCompanyDetail.jsx (admin — company Orders tab)
export const STATUS_STYLES = {
  draft:              { bg: 'bg-gray-500/20',   text: 'text-gray-400',   label: 'Draft' },
  pending_review:     { bg: 'bg-yellow-500/20', text: 'text-yellow-400', label: 'In Review' },
  invoice_requested:  { bg: 'bg-blue-500/20',   text: 'text-blue-400',   label: 'Invoice Sent' },
  payment_pending:    { bg: 'bg-orange-500/20', text: 'text-orange-400', label: 'Payment Pending' },
  payment_received:   { bg: 'bg-green-500/20',  text: 'text-green-400',  label: 'Payment Received' },
  documents_pending:  { bg: 'bg-orange-500/20', text: 'text-orange-400', label: 'Documents Pending' },
  under_review:       { bg: 'bg-blue-500/20',   text: 'text-blue-400',   label: 'Under Review' },
  signature_pending:  { bg: 'bg-purple-500/20', text: 'text-purple-400', label: 'Signature Pending' },
  signature_review:   { bg: 'bg-purple-500/20', text: 'text-purple-400', label: 'Signature Review' },
  approved:           { bg: 'bg-green-500/20',  text: 'text-green-400',  label: 'Approved' },
  rejected:           { bg: 'bg-red-500/20',    text: 'text-red-400',    label: 'Rejected' },
  completed:          { bg: 'bg-green-500/20',  text: 'text-green-400',  label: 'Completed' },
  cancelled:          { bg: 'bg-gray-500/20',   text: 'text-gray-400',   label: 'Cancelled' },
};

// All known statuses (ordered as defined above) — for filter dropdowns,
// admin status-change controls, etc.
export const ALL_STATUSES = Object.keys(STATUS_STYLES);

// Safe lookup with a neutral fallback for any unknown / future status.
export function getStatusStyle(status) {
  return STATUS_STYLES[status] || STATUS_STYLES.draft;
}
